import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.userAnswersQuizQuestion.fields.id'),
  },
  {
    name: 'userId',
    label: i18n('entities.userAnswersQuizQuestion.fields.userId'),
  },
  {
    name: 'quizId',
    label: i18n('entities.userAnswersQuizQuestion.fields.quizId'),
  },
  {
    name: 'quizQuestionId',
    label: i18n('entities.userAnswersQuizQuestion.fields.quizQuestionId'),
  },
  {
    name: 'quizQuestionAnswerId',
    label: i18n('entities.userAnswersQuizQuestion.fields.quizQuestionAnswerId'),
  },
  {
    name: 'archived',
    label: i18n('entities.userAnswersQuizQuestion.fields.archived'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'archivedBy',
    label: i18n('entities.userAnswersQuizQuestion.fields.archivedBy'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'archivedAt',
    label: i18n('entities.userAnswersQuizQuestion.fields.archivedAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.userAnswersQuizQuestion.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.userAnswersQuizQuestion.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
